<template>
  <v-container>
      <v-layout justify-center row wrap>
          <v-flex xs12>
              <w-main-title
                      class="pb-0"
                      title="Revisa tus Datos Personales"
                      :breadcrumbs="breadcrumbs"
              ></w-main-title>
              <kimsa-alert class="mb-5"
                           :show="!userDataComplete"
                           text="Aún no has completado tus datos personales"></kimsa-alert>
          </v-flex>
          <v-flex xs12>
              <v-card class="kim-card">
                  <v-container class="pt-0">
                      <v-layout row wrap justify-center>
                          <v-flex xs12 sm10 md8 class="pt-3 text-center">
                              <user-form
                                      :avatarPicker="true"
                                      class="mt-3"
                                      hidePassword
                                      :loading="saving"
                                      submitLabel="Guardar Datos"
                                      :submit-fn="guardarDatos"
                                      :user="currentUser"
                                      ref="userForm"
                                      :imgDefault="currentUser.avatar"
                              >
                                  <template v-slot:others>
                                      <v-flex xs12>
                                        <birth-date-picker :value="birthDate" @change="setBirthDate" />
                                      </v-flex>
                                      <v-flex xs12>
                                          <insurance-company-selector ref="insurance" :onChange="onInsuranceCompanyChange" :value="insuranceCompany"></insurance-company-selector>
                                      </v-flex>
                                      <v-flex xs12 class="text-right">
                                          <p class="must-complete-text">Todos los campos son obligatorios</p>
                                      </v-flex>
                                  </template>
                              </user-form>
                          </v-flex>
                      </v-layout>
                  </v-container>
              </v-card>
          </v-flex>
          <KimsaConfirm ref="confirmar" title="Correo no Concuerda" :content="cambioCorreoText" @confirm="confirmarCambioCorreo"></KimsaConfirm>
      </v-layout>
  </v-container>
</template>

<script>
    import WMainTitle from '@/components/common/WMainTitle'
    import KimsaAlert from '@/components/common/KimsaAlert'
    import KimsaConfirm from '@/components/common/KimsaConfirm'
    import InsuranceCompanySelector from '@/components/insurance_companies/InsuranceCompanySelector'
    import UserForm from '@/components/account/UserForm'
    import {mapState} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'
    import BirthDatePicker from "@/components/common/BirthDatePicker";
    export default{
        components:{
          BirthDatePicker,
            WMainTitle,
            KimsaAlert,
            InsuranceCompanySelector,
            UserForm,
            KimsaConfirm,
        },
        data(){
            return {
              saving: false,
                breadcrumbs: [
                    {
                        text: 'Mis Datos',
                        disabled: true,
                        href: ''
                    },
                ],
                insuranceCompany: null,
                cambioCorreoConfirmado: false,
                cambioCorreoText: 'El correo ingresado no concuerda con su correo actual, al actualizar el correo deberá volver a validar su cuenta',
                comuna: {id: null, name: null},
                birthDate: ''
            }
        },
        created() {
          this.insuranceCompany = this.currentUser.insurance_company || null
          this.birthDate = this.currentUser.birth_date
          this.cambioCorreoConfirmado = false
          this.currentUser.commune ? this.comuna.id = this.currentUser.commune.id : this.comuna.id = null
        },
        computed:{
            ...mapState(['userDataComplete', 'institutionDataComplete'])
        },
        methods: {
          onInsuranceCompanyChange(val){
                //
                var vm = this
                vm.insuranceCompany = val
            },
          setBirthDate(val) {
            this.birthDate = val
          },
        async guardarDatos (user) {
          const id =  user.id

          const vm = this

          delete user.password
          delete user.id

          vm.comuna.id ? user.commune_id = vm.comuna.id : user.commune_id = null
          vm.insuranceCompany ? user.insurance_company_id = vm.insuranceCompany.id : user.insurance_company_id = null
          vm.birthDate ? user.birth_date = vm.birthDate : user.birth_date = null
          if ((user.email !== vm.currentUser.email) && !vm.cambioCorreoConfirmado) {
             vm.$refs.confirmar.show()
             return
          }

          vm.saving = true
          const response = await ApiUtils.makeRequest('user', 'PATCH', user)
          vm.saving = false

          if (response.ok) {
            await ApiUtils.fetchMe()
          }
          if (response.ok) {
            vm.$store.commit('showSnackBar', 'Datos Actualizados')
          } else {
            vm.$store.commit('showSnackBar', 'Error Actualizando Datos')
          }
        },
        confirmarCambioCorreo() {
            this.cambioCorreoConfirmado = true
            this.$refs.userForm.submit()
          },
        comunaSeleccionada(val) {
          this.comuna = val
          }
        },
    }
</script>

<style scoped>
  img {
    max-width: 100%;
    display: block;
    margin: -100px auto 40px;
    border-radius:100%;
    max-width: 300px;
  }
  on-top {
    margin-top: -50px;
  }
  .must-complete-text {
    margin: 10px 0 0;
    padding: 0;
    font-size:10px;
  }
</style>

